import { useEffect, useState } from 'react';
import {
  useAppSelector,
  useLazyGetOrderNoteQuery,
  getWorkspaceId,
  JsonSchema,
} from '@zonofi/zono-money-store';

export const useOrderNote = () => {
  const sellerWorkspaceId = useAppSelector(getWorkspaceId);

  const [orderNoteFromEditor, setOrderNoteFromEditor] = useState<JsonSchema>({
    type: 'object',
    properties: {},
    required: [],
  } as JsonSchema);

  const [getOrderNoteData, orderNoteRes] = useLazyGetOrderNoteQuery();

  const getOrderNoteApi = () => {
    getOrderNoteData({ sellerWorkspaceId });
  };

  useEffect(() => {
    getOrderNoteApi();
  }, []);

  useEffect(() => {
    if (orderNoteRes?.isSuccess && orderNoteRes?.data) {
      setOrderNoteFromEditor(orderNoteRes?.data?.orderNoteSchema);
    }
  }, [orderNoteRes]);

  return {
    orderNoteFromEditor,
    setOrderNoteFromEditor,
  };
};
